/**
 * Filters SII fiscal valuations whose model text overlaps any token from the vehicle clean model.
 */
export function filterValuationsByCarModels(valuationList, carModels) {
  return valuationList.filter((el) => carModels.some((model) => el.modelo.includes(model) || model.includes(el.modelo)));
}
